import { Routes, Route, useNavigate } from 'react-router-dom'
import { Sun, Moon } from 'lucide-react'
import { useTheme } from './utils/ThemeContext.jsx'
import Welcome from './pages/Welcome.jsx'
import PhotoBooth from './pages/PhotoBooth.jsx'
import SessionSummary from './pages/SessionSummary.jsx'
import Gallery from './pages/Gallery.jsx'
import Admin from './pages/Admin.jsx'
import Resources from './pages/Resources.jsx'
import Experience from './pages/Experience.jsx'
import Game from './pages/Multiplayer.jsx'
import { PasswordProtection } from './components/PasswordProtection.jsx'
import './App.css'

function App() {
  const { isDark, toggleTheme } = useTheme()
  const navigate = useNavigate()

  const protectedBooth = (
    <PasswordProtection onNavigateBack={() => navigate('/')}>
      <PhotoBooth />
    </PasswordProtection>
  )

  const protectedAdmin = (
    <PasswordProtection onNavigateBack={() => navigate('/')}>
      <Admin />
    </PasswordProtection>
  )

  return (
    <div className="app">
      <button
        className="theme-toggle"
        type="button"
        onClick={toggleTheme}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? <Sun size={24} /> : <Moon size={24} />}
      </button>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/game" element={<Game />} />
        <Route path="/game/:roomId" element={<Game />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/booth" element={protectedBooth} />
        <Route path="/session/:id/summary" element={<SessionSummary />} />
        <Route path="/session/:id" element={<Gallery />} />
        <Route path="/admin" element={protectedAdmin} />
      </Routes>
    </div>
  )
}

export default App
